// import React, { useState } from 'react';
// import {Link} from 'react-router-dom';
// import { products } from '../../data/products';
// import ProductCard from '../products/ProductCard';
// import ProductQuickView from '../products/ProductQuickView';
// import { TrendingUp } from 'lucide-react';

// const BestSellers = () => {
//   const [selectedProduct, setSelectedProduct] = useState(null);
//   const [isQuickViewOpen, setIsQuickViewOpen] = useState(false);

//   // Get top 4 products by rating
//   const bestSellers = [...products]
//     .sort((a, b) => b.rating - a.rating)
//     .slice(0, 8);

//   const handleQuickView = (product) => {
//     setSelectedProduct(product);
//     setIsQuickViewOpen(true);
//   };

//   return (
//     <>
//       <section className="py-20 bg-gradient-to-br from-gray-50 to-primary-50/30">
//         <div className="container mx-auto px-4">
//           {/* Section Header */}
//           <div className="text-center mb-12 animate-fade-in">
//             <div className="inline-flex items-center gap-2 px-4 py-2 bg-white rounded-full mb-4 shadow-soft">
//               <TrendingUp className="w-5 h-5 text-accent-600" />
//               <span className="text-sm font-semibold text-dark-800">
//                 Customer Favorites
//               </span>
//             </div>
//             <h2 className="text-4xl md:text-5xl font-display font-bold text-dark-900 mb-4">
//               Best Sellers
//             </h2>
//             <p className="text-lg text-gray-600 max-w-2xl mx-auto">
//               Our most loved pieces, chosen by thousands of satisfied customers
//             </p>
//           </div>

//           {/* Products Grid */}
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
//             {bestSellers.map((product, index) => (
//               <div
//                 key={product.id}
//                 className="animate-slide-up"
//                 style={{ animationDelay: `${index * 0.1}s` }}
//               >
//                 <ProductCard 
//                   product={product} 
//                   onQuickView={handleQuickView}
//                 />
//               </div>
//             ))}
//           </div>

//           {/* CTA */}
//           <div className="text-center mt-12 animate-fade-in" style={{ animationDelay: '0.4s' }}>
//             <Link
//               to="/products"
//               className="inline-block px-8 py-4 bg-white text-primary-700 rounded-lg font-semibold border-2 border-primary-300 hover:bg-primary-50 transition-all duration-300 transform hover:scale-105 shadow-soft"
//             >
//               View All Best Sellers
//             </Link>
//           </div>
//         </div>
//       </section>

//       <ProductQuickView
//         product={selectedProduct}
//         isOpen={isQuickViewOpen}
//         onClose={() => setIsQuickViewOpen(false)}
//       />
//     </>
//   );
// };

// export default BestSellers;


import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useProducts } from '../../hooks/useProducts';
import ProductCard from '../products/ProductCard';
import ProductQuickView from '../products/ProductQuickView';
import { TrendingUp } from 'lucide-react';

const BestSellers = () => {
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [isQuickViewOpen, setIsQuickViewOpen] = useState(false);
  
  // Fetch products from JSON
  const { products, loading, error } = useProducts();

  // Get top 8 newest products (highest ID = newest)
  const bestSellers = [...products]
    .sort((a, b) => b.id - a.id)
    .slice(0, 8);

  const handleQuickView = (product) => {
    setSelectedProduct(product);
    setIsQuickViewOpen(true);
  };

  // Loading state
  if (loading) {
    return (
      <section className="py-20 bg-gradient-to-br from-gray-50 to-primary-50/30">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto mb-4"></div>
            <p className="text-gray-600">Loading best sellers...</p>
          </div>
        </div>
      </section>
    );
  }

  // Error state
  if (error) {
    return (
      <section className="py-20 bg-gradient-to-br from-gray-50 to-primary-50/30">
        <div className="container mx-auto px-4">
          <div className="text-center">
            <p className="text-red-600 mb-4">Error loading products</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <>
      <section className="py-20 bg-gradient-to-br from-gray-50 to-primary-50/30">
        <div className="container mx-auto px-4">
          {/* Section Header */}
          <div className="text-center mb-12 animate-fade-in">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-white rounded-full mb-4 shadow-soft">
              <TrendingUp className="w-5 h-5 text-accent-600" />
              <span className="text-sm font-semibold text-dark-800">
                Customer Favorites
              </span>
            </div>
            <h2 className="text-4xl md:text-5xl font-display font-bold text-dark-900 mb-4">
              Best Sellers
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Our most loved pieces, chosen by thousands of satisfied customers
            </p>
          </div>

          {/* Products Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {bestSellers.map((product, index) => (
              <div
                key={product.id}
                className="animate-slide-up"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <ProductCard 
                  product={product} 
                  onQuickView={handleQuickView}
                />
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="text-center mt-12 animate-fade-in" style={{ animationDelay: '0.4s' }}>
            <Link
              to="/products"
              className="inline-block px-8 py-4 bg-white text-primary-700 rounded-lg font-semibold border-2 border-primary-300 hover:bg-primary-50 transition-all duration-300 transform hover:scale-105 shadow-soft"
            >
              View All Best Sellers
            </Link>
          </div>
        </div>
      </section>

      <ProductQuickView
        product={selectedProduct}
        isOpen={isQuickViewOpen}
        onClose={() => setIsQuickViewOpen(false)}
      />
    </>
  );
};

export default BestSellers;